export const translations = {
  en: {
    brand: "Dialysis Diet Pro",
    tagline: "Track Your Dialysis Diet Daily.",
    subtagline: "Monitor key nutrients, log food, and manage your dialysis diet with confidence.",
    get_started: "Get Started",
    login: "Log In",
    logout: "Log Out",
    register: "Create Account",
    email: "Email",
    password: "Password",
    name: "Full Name",
    patient: "Patient",
    weight: "Weight",
    nav_home: "Home",
    nav_dashboard: "Dashboard",
    nav_foods: "Food Database",
    nav_meal_mixer: "Meal Mixer",
    nav_history: "History",
    nav_assistant: "Assistant",
    nav_settings: "Settings",
    nav_admin: "Admin",
    how_it_works: "How It Works",
    features: "Features",
    patient_stories: "Patient Stories",
    emergency: "Emergency Numbers",
    disclaimer: "This app is for guidance purposes only. Always consult your medical team.",
    guidance_disclaimer: "This app is for guidance purposes only. Always consult your medical team.",
    footer_short: "This app is for guidance purposes only. Always consult your medical team.",
    copyright: "© 2026 Dialysis Nutrition Tracker. All rights reserved.",
    powered_by: "Powered by SVLIKES",
    step1_title: "Log your food",
    step1_desc: "Search a rich food database and add portions in seconds.",
    step2_title: "See what matters",
    step2_desc: "Real-time Potassium, Phosphorus, Sodium, and Protein tracking.",
    step3_title: "Stay consistent",
    step3_desc: "Daily summaries, gentle reminders, and a clear history.",
    feat_tracking: "Food tracking",
    feat_monitor: "Nutrient monitoring",
    feat_summary: "Daily summaries",
    feat_reminders: "Reminders",
    feat_notifs: "Notifications",
    feat_reports: "Reports & PDF export",
    today: "Today",
    daily_overview: "Daily Nutrient Overview",
    harmful_nutrients: "Harmful Nutrients",
    potassium: "Potassium",
    phosphorus: "Phosphorus",
    sodium: "Sodium",
    protein: "Protein",
    water: "Water",
    add_food: "Add Food",
    add: "Add",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    save: "Save",
    search_food: "Search food...",
    all_categories: "All Categories",
    category: "Category",
    serving: "Serving",
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    snack: "Snack",
    quick_add: "Quick add",
    daily_summary: "Daily Summary",
    entries_today: "Entries today",
    safe: "Safe",
    exceeded: "Exceeded",
    of: "of",
    limit: "limit",
    consumed: "consumed",
    add_water: "Add Water",
    reset: "Reset",
    notes: "Notes",
    add_note: "Add a note about today...",
    mood: "How do you feel?",
    mood_great: "Great",
    mood_good: "Good",
    mood_okay: "Okay",
    mood_low: "Low",
    mood_bad: "Tough",
    quote_of_day: "Quote of the Day",
    export_pdf: "Export PDF",
    print_report: "Print Report",
    profile: "Profile",
    weight_kg: "Weight (kg)",
    language: "Language",
    dark_mode: "Dark Mode",
    english: "English",
    arabic: "العربية",
    past_days: "Past Days",
    no_entries: "No entries for this day",
    admin_title: "Admin Dashboard",
    manage_users: "Manage Users",
    manage_foods: "Manage Foods",
    stats: "Statistics",
    total_users: "Total users",
    total_foods: "Total foods",
    total_logs: "Total logs",
    logs_today: "Logs today",
    active_today: "Active today",
    confirm_delete: "Are you sure you want to delete?",
    add_new_food: "Add New Food",
    login_subtitle: "Welcome back to Dialysis Diet Pro.",
    register_subtitle: "Create your Dialysis Diet Pro account.",
    or: "or",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    story1_name: "Fatima, 68",
    story1_quote: "I can finally see my sodium clearly. My nephrologist is proud of my last labs.",
    story2_name: "James, 54",
    story2_quote: "Logging lunch takes 10 seconds. The progress bars tell me if I'm on track before dinner.",
    story3_name: "Hala, 72",
    story3_quote: "I love that it's in Arabic. The daily quote keeps me going.",
    view_report: "View Report",
    print_page: "Print Page",
    loading: "Loading…",
    quantity: "Quantity",
    today_safety_summary: "Today’s Safety Summary",
    safety_summary_footer: "Based on today’s logged foods. Always follow your healthcare team’s advice.",
    dialysis_tip: "Dialysis Tip",
    show_another_tip: "Show another tip",
    potassium_close_limit: "Potassium is close to your daily limit.",
    phosphorus_close_limit: "Phosphorus is close to your daily limit.",
    sodium_close_limit: "Sodium is close to your daily limit.",
    protein_close_target: "Protein is close to your daily target.",
    no_foods_logged_today: "No foods logged yet today. Start by adding your first meal or snack.",
    today_safe_so_far: "Today looks safe so far based on your logged foods.",
    please_select_food: "Please select a food",
    food_logged: "Food logged",
    note_required: "Note is required",
    note_saved: "Note saved",
    note_deleted: "Note deleted",
    medication_reminder: "Medication Reminder",
    medication_helper: "For medicines already prescribed by your healthcare team.",
    medication_name: "Medication name",
    medication_name_helper: "Enter medication name here",
    medication_name_required: "Medication name is required",
    medication_times: "Times",
    medication_times_helper: "Example: 08:00, 14:00, 20:00 — separate times with commas",
    medication_valid_time_required: "Add at least one valid time",
    medication_duration: "Duration (days)",
    medication_duration_helper: "Example: 7 days",
    medication_added: "Medication added",
    add_medication: "Add medication",
    medication_removed: "Medication removed",
    medication_empty: "No medications added yet.",
    medication_last_7_days: "Last 7 days",
    medication_add_to_track: "Add medications to start tracking.",
    medication_disclaimer: "This reminder does not replace medical advice. Always follow your doctor’s instructions.",
    medication_dose_not_taken: "Dose marked as not taken",
    medication_dose_taken: "Dose marked as taken",
    taken: "Taken",
    pending: "Pending",
    note: "Note",
    notes_helper: "Track questions, symptoms, or food reactions.",
    days_28_trend: "28-day harmful nutrients trend",
    days_28_report: "28-Day Harmful Nutrients Report",
    daily_harmful_nutrients_report: "Daily Harmful Nutrients Report",
    entries: "entries",
    select_day: "Select a day",
    preferences: "Preferences",
    protein_limit_hint: "Protein daily limit = weight × 1.2g",
    food_reminders: "Food Reminders",
    meal_reminders_desc: "Browser notifications for meal logging reminders. Keep this tab open to receive reminders.",
    enable_reminders: "Enable reminders",
    medication_notifications: "Medication Notifications",
    medication_notifications_desc: "Browser notifications at your saved medication times while the app is open.",
    enable_medication_notifications: "Enable medication notifications",
    notifications_blocked: "Notifications are blocked in your browser. Please enable them in your browser settings to receive reminders.",
    saved: "Saved",
    demo_login: "Try Demo Account",
    demo_helper: "Explore the app with a sample account. No signup needed.",
    demo_not_configured: "Demo login is not configured.",
    logging_in: "Logging in...",
    welcome_to_app: "Welcome to Dialysis Diet Pro!",
    light: "Light",
    dark: "Dark",
    no_food_matches: "No foods match the current search.",
    not_listed: "Not listed",
    serving_not_listed: "Serving not listed",
    assistant_title: "Dialysis Diet Assistant",
    assistant_chat_placeholder: "Ask a dialysis diet question...",
    assistant_chat_ask: "Ask",
    assistant_chat_welcome: "Ask a question about dialysis-friendly food or nutrition.",
    assistant_chat_of: "of",
    assistant_chat_used_today: "questions used today",
    assistant_chat_remaining: "remaining",
    assistant_intro: "Ask a general question about dialysis diet, nutrition, hydration, food logging, or using this app.",
    assistant_question_label: "Your question",
    assistant_placeholder: "Example: What lower-sodium foods can I discuss with my renal dietitian?",
    assistant_ask: "Ask Assistant",
    assistant_thinking: "Preparing answer...",
    assistant_response_title: "General guidance",
    assistant_disclaimer: "This assistant provides general education only and does not replace your doctor or dietitian.",
    assistant_usage: "questions used today",
    assistant_remaining: "remaining today",
    assistant_limit_reached: "You have reached today's question limit. Please try again tomorrow.",
    assistant_question_required: "Please enter a question first.",
    assistant_unavailable: "The AI assistant is temporarily unavailable. Please try again later.",
    assistant_open: "Open Dialysis Diet Assistant",
    assistant_close: "Close Dialysis Diet Assistant",
    assistant_voice_start: "Hold to talk",
    assistant_voice_stop: "Stop",
    assistant_voice_listening: "Recording... release to send",
    assistant_voice_recording: "Recording... release to send",
    assistant_voice_transcribing: "Transcribing...",
    assistant_voice_speaking: "Speaking...",
    assistant_voice_not_supported: "Voice is temporarily unavailable. Please type your question.",
    assistant_voice_error: "Voice is temporarily unavailable. Please type your question.",
    assistant_speak: "Speak",
    assistant_stop_speaking: "Stop",
    assistant_speech_loading: "Preparing voice...",
    assistant_speech_not_supported: "Voice is temporarily unavailable. Please type your question.",
    assistant_speech_error: "Voice is temporarily unavailable. Please type your question.",
    assistant_meal_draft_created: "I created a draft meal. Open Meal Mixer to review ingredients and quantities before saving.",
    assistant_log_confirm: "Confirm",
    assistant_log_cancel: "Cancel",
    assistant_log_action_missing: "No food is waiting for confirmation.",
    meal_mixer_intro: "Build a meal mix from existing food database values only. Missing nutrient values are not estimated.",
    meal_mixer_helper: "Build mixed foods like Tabbouleh, save them, and reuse them later.",
    meal_mixer_build: "Build meal mix",
    meal_mixer_editing_saved: "Editing saved mixed meal",
    meal_mixer_select_placeholder: "Select a food",
    meal_mixer_select_food: "Please select a food.",
    meal_mixer_invalid_quantity: "Enter a quantity greater than 0.",
    meal_mixer_add: "Add to mix",
    meal_mixer_reset: "Reset meal",
    meal_mixer_empty: "Add foods to see calculated nutrient totals.",
    meal_mixer_totals: "Calculated Totals",
    meal_mixer_missing_data: "missing data",
    meal_mixer_missing_selected: "This food has missing nutrient data. Missing values are excluded from totals.",
    meal_mixer_disclaimer: "This calculator is for tracking and education only. Always follow your doctor or renal dietitian's plan.",
    meal_mixer_protein_target_title: "Estimated Protein Target",
    meal_mixer_update_weight: "Update your weight to calculate estimated protein target.",
    meal_mixer_protein_per_day: "protein/day",
    meal_mixer_protein_target_disclaimer: "For education only. Follow your doctor or renal dietitian's plan.",
    meal_mixer_more_foods: "More foods are coming soon.",
    meal_mixer_foods_available: "foods available",
    meal_mixer_meal_name: "Meal name",
    meal_mixer_meal_name_placeholder: "Example: Tabbouleh",
    meal_mixer_name_required: "Meal name is required before saving.",
    meal_mixer_save_mixed_meal: "Save Mixed Meal",
    meal_mixer_update_saved_meal: "Update saved meal",
    meal_mixer_save_as_new: "Save as new",
    meal_mixer_saved_meal_saved: "Mixed meal saved.",
    meal_mixer_saved_meal_updated: "Mixed meal updated.",
    meal_mixer_saved_meal_deleted: "Saved mixed meal deleted.",
    meal_mixer_saved_section: "Saved Mixed Meals",
    meal_mixer_saved_helper: "Save Mixed Meal creates a reusable mixed food. Log Today adds it to today's history as one grouped item.",
    meal_mixer_saved_empty: "No saved mixed meals yet.",
    meal_mixer_ingredients: "ingredients",
    meal_mixer_updated: "Updated",
    meal_mixer_load_edit: "Edit",
    meal_mixer_add_saved_history: "Log Today",
    meal_mixer_saved_missing_note: "Some ingredients have missing nutrient data. Missing values were excluded from totals.",
    meal_mixer_add_history: "Add mix to today's history",
    meal_mixer_history_saved: "Meal mix added to today's history.",
    meal_mixer_ai_draft_available: "AI meal draft available",
    meal_mixer_ai_draft_import: "Import to Mixer",
    meal_mixer_ai_draft_dismiss: "Dismiss",
    meal_mixer_ai_draft_imported: "AI meal draft imported.",
    meal_mixer_ai_draft_no_matches: "No matching database foods were available to import.",
    meal_mixer_ai_draft_quantity_review: "Review ingredient quantities before saving or logging this meal.",
    meal_mixer_estimated_daily_target: "Estimated daily protein target",
    meal_mixer_current_meal_protein: "Current meal protein",
    meal_mixer_remaining_today: "Approx. remaining today",
    meal_mixer_day_unit: "day",
  },
  ar: {
    assistant_chat_placeholder: "اطرح سؤالا عن حمية غسيل الكلى...",
    assistant_chat_ask: "اسأل",
    assistant_chat_welcome: "اطرح سؤالا عن الأطعمة أو التغذية المناسبة لغسيل الكلى.",
    assistant_chat_of: "من",
    assistant_chat_used_today: "أسئلة مستخدمة اليوم",
    assistant_chat_remaining: "متبقية",
    brand: "دايلاسيس دايت برو",
    tagline: "تتبّع حمية غسيل الكلى يوميًا",
    subtagline: "راقب العناصر الغذائية وسجّل وجباتك وأدر نظامك الغذائي بثقة.",    
    get_started: "ابدأ الآن",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    register: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    patient: "المريض",
    weight: "الوزن",
    nav_home: "الرئيسية",
    nav_dashboard: "لوحة التحكم",
    nav_foods: "قاعدة الأطعمة",
    nav_meal_mixer: "\u062d\u0627\u0633\u0628\u0629 \u0627\u0644\u0648\u062c\u0628\u0629",
    nav_history: "السجل",
    nav_assistant: "المساعد الغذائي",
    nav_settings: "الإعدادات",
    nav_admin: "الإدارة",
    how_it_works: "كيف يعمل",
    features: "الميزات",
    patient_stories: "قصص المرضى",
    emergency: "أرقام الطوارئ",
    disclaimer: "هذا التطبيق لأغراض إرشادية فقط. استشر دائمًا فريقك الطبي.",
    guidance_disclaimer: "هذا التطبيق لأغراض إرشادية فقط. استشر دائمًا فريقك الطبي.",
    footer_short: "هذا التطبيق لأغراض إرشادية فقط. استشر دائمًا فريقك الطبي.",
    copyright: "© 2026 متتبع تغذية غسيل الكلى. جميع الحقوق محفوظة.",
    powered_by: "مدعوم من SVLIKES",
    step1_title: "سجل وجباتك",
    step1_desc: "ابحث في قاعدة أطعمة غنية وأضف الحصص في ثوانٍ.",
    step2_title: "شاهد ما يهم",
    step2_desc: "تتبع فوري للبوتاسيوم والفوسفور والصوديوم والبروتين.",
    step3_title: "حافظ على الاستمرارية",
    step3_desc: "ملخصات يومية، تذكيرات لطيفة، وسجل واضح.",
    feat_tracking: "تتبع الطعام",
    feat_monitor: "مراقبة المغذيات",
    feat_summary: "ملخصات يومية",
    feat_reminders: "تذكيرات",
    feat_notifs: "إشعارات",
    feat_reports: "تقارير وتصدير PDF",
    today: "اليوم",
    daily_overview: "نظرة عامة يومية على المغذيات",
    harmful_nutrients: "المغذيات الضارة",
    potassium: "البوتاسيوم",
    phosphorus: "الفوسفور",
    sodium: "الصوديوم",
    protein: "البروتين",
    water: "الماء",
    add_food: "أضف طعام",
    add: "أضف",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    save: "حفظ",
    search_food: "ابحث عن طعام...",
    all_categories: "كل الفئات",
    category: "الفئة",
    serving: "الحصة",
    breakfast: "الفطور",
    lunch: "الغداء",
    dinner: "العشاء",
    snack: "وجبة خفيفة",
    quick_add: "إضافة سريعة",
    daily_summary: "الملخص اليومي",
    entries_today: "إدخالات اليوم",
    safe: "آمن",
    exceeded: "متجاوز",
    of: "من",
    limit: "الحد",
    consumed: "مستهلك",
    add_water: "أضف ماء",
    reset: "إعادة تعيين",
    notes: "ملاحظات",
    add_note: "أضف ملاحظة حول اليوم...",
    mood: "كيف تشعر؟",
    mood_great: "رائع",
    mood_good: "جيد",
    mood_okay: "مقبول",
    mood_low: "منخفض",
    mood_bad: "صعب",
    quote_of_day: "اقتباس اليوم",
    export_pdf: "تصدير PDF",
    print_report: "طباعة تقرير",
    profile: "الملف الشخصي",
    weight_kg: "الوزن (كغ)",
    language: "اللغة",
    dark_mode: "الوضع الداكن",
    english: "English",
    arabic: "العربية",
    past_days: "الأيام السابقة",
    no_entries: "لا توجد إدخالات لهذا اليوم",
    admin_title: "لوحة الإدارة",
    manage_users: "إدارة المستخدمين",
    manage_foods: "إدارة الأطعمة",
    stats: "إحصائيات",
    total_users: "إجمالي المستخدمين",
    total_foods: "إجمالي الأطعمة",
    total_logs: "إجمالي السجلات",
    logs_today: "سجلات اليوم",
    active_today: "نشط اليوم",
    confirm_delete: "هل أنت متأكد من الحذف؟",
    add_new_food: "أضف طعامًا جديدًا",
    login_subtitle: "مرحبًا بعودتك إلى دايلاسيس دايت برو.",
    register_subtitle: "أنشئ حساب دايلاسيس دايت برو.",
    or: "أو",
    no_account: "ليس لديك حساب؟",
    have_account: "لديك حساب بالفعل؟",
    story1_name: "فاطمة، 68",
    story1_quote: "أستطيع أخيرًا رؤية الصوديوم بوضوح. طبيب الكلى فخور بنتائج فحوصاتي الأخيرة.",
    story2_name: "جيمس، 54",
    story2_quote: "تسجيل الغداء يستغرق 10 ثوانٍ. تخبرني أشرطة التقدم إذا كنت على المسار الصحيح قبل العشاء.",
    story3_name: "هالة، 72",
    story3_quote: "أحب أن التطبيق بالعربية. الاقتباس اليومي يبقيني مستمرة.",
    view_report: "عرض التقرير",
    print_page: "طباعة الصفحة",
    loading: "جارٍ التحميل…",
    quantity: "الكمية",
    today_safety_summary: "ملخص الأمان اليوم",
    safety_summary_footer: "بناءً على الأطعمة المسجلة اليوم. اتبع دائمًا نصيحة فريقك الطبي.",
    dialysis_tip: "نصيحة لغسيل الكلى",
    show_another_tip: "عرض نصيحة أخرى",
    potassium_close_limit: "البوتاسيوم قريب من الحد اليومي.",
    phosphorus_close_limit: "الفوسفور قريب من الحد اليومي.",
    sodium_close_limit: "الصوديوم قريب من الحد اليومي.",
    protein_close_target: "البروتين قريب من هدفك اليومي.",
    no_foods_logged_today: "لم يتم تسجيل أطعمة اليوم بعد. ابدأ بإضافة أول وجبة أو وجبة خفيفة.",
    today_safe_so_far: "يبدو اليوم آمنًا حتى الآن بناءً على الأطعمة المسجلة.",
    please_select_food: "يرجى اختيار طعام",
    food_logged: "تم تسجيل الطعام",
    note_required: "الملاحظة مطلوبة",
    note_saved: "تم حفظ الملاحظة",
    note_deleted: "تم حذف الملاحظة",
    medication_reminder: "تذكير الدواء",
    medication_helper: "للأدوية الموصوفة مسبقًا من فريقك الطبي.",
    medication_name: "اسم الدواء",
    medication_name_helper: "أدخل اسم الدواء هنا",
    medication_name_required: "اسم الدواء مطلوب",
    medication_times: "الأوقات",
    medication_times_helper: "مثال: 08:00، 14:00، 20:00 — افصل بين الأوقات بفواصل",
    medication_valid_time_required: "أضف وقتًا صحيحًا واحدًا على الأقل",
    medication_duration: "المدة (بالأيام)",
    medication_duration_helper: "مثال: 7 أيام",
    medication_added: "تمت إضافة الدواء",
    add_medication: "أضف دواء",
    medication_removed: "تم حذف الدواء",
    medication_empty: "لم تتم إضافة أدوية بعد.",
    medication_last_7_days: "آخر 7 أيام",
    medication_add_to_track: "أضف الأدوية لبدء المتابعة.",
    medication_disclaimer: "هذا التذكير لا يغني عن النصيحة الطبية. اتبع دائمًا تعليمات طبيبك.",
    medication_dose_not_taken: "تم وضع الجرعة كغير مأخوذة",
    medication_dose_taken: "تم وضع الجرعة كمأخوذة",
    taken: "مأخوذ",
    pending: "بانتظار",
    note: "ملاحظة",
    notes_helper: "سجّل الأسئلة أو الأعراض أو تفاعلات الطعام.",
    days_28_trend: "اتجاه المغذيات الضارة خلال 28 يومًا",
    days_28_report: "تقرير المغذيات الضارة خلال 28 يومًا",
    daily_harmful_nutrients_report: "تقرير المغذيات الضارة اليومي",
    entries: "إدخالات",
    select_day: "اختر يومًا",
    preferences: "التفضيلات",
    protein_limit_hint: "حد البروتين اليومي = الوزن × 1.2غ",
    food_reminders: "تذكيرات الوجبات",
    meal_reminders_desc: "إشعارات المتصفح لتذكيرك بتسجيل الوجبات. أبقِ هذه النافذة مفتوحة لاستلام التذكيرات.",
    enable_reminders: "تفعيل التذكيرات",
    medication_notifications: "إشعارات تذكير الدواء",
    medication_notifications_desc: "إشعارات المتصفح في أوقات الدواء المحفوظة أثناء فتح التطبيق.",
    enable_medication_notifications: "تفعيل إشعارات الدواء",
    notifications_blocked: "الإشعارات محظورة في المتصفح. يرجى تفعيلها من إعدادات المتصفح لاستلام التذكيرات.",
    saved: "تم الحفظ",
    demo_login: "جرّب الحساب التجريبي",
    demo_helper: "استكشف التطبيق باستخدام حساب تجريبي. لا حاجة للتسجيل.",
    demo_not_configured: "تسجيل الدخول التجريبي غير مهيأ.",
    logging_in: "جارٍ تسجيل الدخول...",
    welcome_to_app: "مرحبًا بك في دايلاسيس دايت برو!",
    light: "فاتح",
    dark: "داكن",
    no_food_matches: "لا توجد أطعمة تطابق البحث الحالي.",
    not_listed: "غير مذكور",
    serving_not_listed: "الحصة غير مذكورة",
    assistant_title: "مساعد حمية غسيل الكلى",
    assistant_intro: "اطرح سؤالا عاما عن حمية غسيل الكلى أو التغذية أو السوائل أو تسجيل الطعام أو استخدام التطبيق.",
    assistant_question_label: "سؤالك",
    assistant_placeholder: "مثال: ما الأطعمة الأقل صوديوم التي يمكنني مناقشتها مع اختصاصي التغذية؟",
    assistant_ask: "اسأل المساعد",
    assistant_thinking: "جار إعداد الإجابة...",
    assistant_response_title: "إرشادات عامة",
    assistant_disclaimer: "يقدم هذا المساعد تثقيفا عاما فقط ولا يحل محل طبيبك أو اختصاصي التغذية.",
    assistant_usage: "أسئلة مستخدمة اليوم",
    assistant_remaining: "متبقية اليوم",
    assistant_limit_reached: "لقد وصلت إلى الحد اليومي للأسئلة. يرجى المحاولة مجددا غدا.",
    assistant_question_required: "يرجى إدخال سؤال أولا.",
    assistant_unavailable: "المساعد غير متاح حاليا. يرجى المحاولة لاحقا.",
    assistant_open: "افتح مساعد حمية غسيل الكلى",
    assistant_close: "أغلق مساعد حمية غسيل الكلى",
    assistant_voice_start: "اضغط وتحدث",
    assistant_voice_stop: "إيقاف",
    assistant_voice_listening: "جارٍ التسجيل... ارفع إصبعك للإرسال",
    assistant_voice_recording: "جارٍ التسجيل... ارفع إصبعك للإرسال",
    assistant_voice_transcribing: "جارٍ تحويل الصوت إلى نص...",
    assistant_voice_speaking: "جارٍ التشغيل...",
    assistant_voice_not_supported: "الصوت غير متاح حالياً. يرجى كتابة السؤال.",
    assistant_voice_error: "الصوت غير متاح حالياً. يرجى كتابة السؤال.",
    assistant_speak: "تشغيل الصوت",
    assistant_stop_speaking: "إيقاف",
    assistant_speech_loading: "جارٍ تحضير الصوت...",
    assistant_speech_not_supported: "الصوت غير متاح حالياً. يرجى كتابة السؤال.",
    assistant_speech_error: "الصوت غير متاح حالياً. يرجى كتابة السؤال.",
    assistant_meal_draft_created: "تم إنشاء مسودة وجبة. افتح حاسبة الوجبة لمراجعة المكونات والكميات قبل الحفظ.",
    assistant_log_confirm: "تأكيد",
    assistant_log_cancel: "إلغاء",
    assistant_log_action_missing: "لا يوجد طعام بانتظار التأكيد.",
    meal_mixer_intro: "\u0627\u0628\u0646 \u0648\u062c\u0628\u0629 \u0645\u0646 \u0642\u064a\u0645 \u0642\u0627\u0639\u062f\u0629 \u0627\u0644\u0623\u0637\u0639\u0645\u0629 \u0627\u0644\u0645\u0648\u062c\u0648\u062f\u0629 \u0641\u0642\u0637. \u0644\u0627 \u064a\u062a\u0645 \u062a\u0642\u062f\u064a\u0631 \u0627\u0644\u0642\u064a\u0645 \u0627\u0644\u0646\u0627\u0642\u0635\u0629.",
    meal_mixer_helper: "\u0623\u0646\u0634\u0626 \u0648\u062c\u0628\u0627\u062a \u0645\u0631\u0643\u0628\u0629 \u0645\u062b\u0644 \u0627\u0644\u062a\u0628\u0648\u0644\u0629\u060c \u0627\u062d\u0641\u0638\u0647\u0627\u060c \u0648\u0627\u0633\u062a\u062e\u062f\u0645\u0647\u0627 \u0644\u0627\u062d\u0642\u0627\u064b.",
    meal_mixer_build: "\u0628\u0646\u0627\u0621 \u0627\u0644\u0648\u062c\u0628\u0629",
    meal_mixer_editing_saved: "\u062a\u0639\u062f\u064a\u0644 \u0648\u062c\u0628\u0629 \u0645\u0631\u0643\u0628\u0629 \u0645\u062d\u0641\u0648\u0638\u0629",
    meal_mixer_select_placeholder: "\u0627\u062e\u062a\u0631 \u0637\u0639\u0627\u0645\u0627",
    meal_mixer_select_food: "\u064a\u0631\u062c\u0649 \u0627\u062e\u062a\u064a\u0627\u0631 \u0637\u0639\u0627\u0645.",
    meal_mixer_invalid_quantity: "\u0623\u062f\u062e\u0644 \u0643\u0645\u064a\u0629 \u0623\u0643\u0628\u0631 \u0645\u0646 0.",
    meal_mixer_add: "\u0623\u0636\u0641 \u0625\u0644\u0649 \u0627\u0644\u0648\u062c\u0628\u0629",
    meal_mixer_reset: "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0648\u062c\u0628\u0629",
    meal_mixer_empty: "\u0623\u0636\u0641 \u0623\u0637\u0639\u0645\u0629 \u0644\u0639\u0631\u0636 \u0645\u062c\u0645\u0648\u0639 \u0627\u0644\u0645\u063a\u0630\u064a\u0627\u062a.",
    meal_mixer_totals: "\u0627\u0644\u0645\u062c\u0627\u0645\u064a\u0639 \u0627\u0644\u0645\u062d\u0633\u0648\u0628\u0629",
    meal_mixer_missing_data: "\u0628\u064a\u0627\u0646\u0627\u062a \u0646\u0627\u0642\u0635\u0629",
    meal_mixer_missing_selected: "\u0647\u0630\u0627 \u0627\u0644\u0637\u0639\u0627\u0645 \u064a\u062d\u062a\u0648\u064a \u0639\u0644\u0649 \u0628\u064a\u0627\u0646\u0627\u062a \u063a\u0630\u0627\u0626\u064a\u0629 \u0646\u0627\u0642\u0635\u0629. \u064a\u062a\u0645 \u0627\u0633\u062a\u062b\u0646\u0627\u0621 \u0627\u0644\u0642\u064a\u0645 \u0627\u0644\u0646\u0627\u0642\u0635\u0629 \u0645\u0646 \u0627\u0644\u0645\u062c\u0645\u0648\u0639.",
    meal_mixer_disclaimer: "\u0647\u0630\u0647 \u0627\u0644\u062d\u0627\u0633\u0628\u0629 \u0644\u0644\u062a\u062a\u0628\u0639 \u0648\u0627\u0644\u062a\u062b\u0642\u064a\u0641 \u0641\u0642\u0637. \u0627\u062a\u0628\u0639 \u062f\u0627\u0626\u0645\u0627 \u062e\u0637\u0629 \u0637\u0628\u064a\u0628\u0643 \u0623\u0648 \u0627\u062e\u062a\u0635\u0627\u0635\u064a \u062a\u063a\u0630\u064a\u0629 \u0627\u0644\u0643\u0644\u0649.",
    meal_mixer_protein_target_title: "\u0647\u062f\u0641 \u0627\u0644\u0628\u0631\u0648\u062a\u064a\u0646 \u0627\u0644\u062a\u0642\u062f\u064a\u0631\u064a",
    meal_mixer_update_weight: "\u062d\u062f\u062b \u0648\u0632\u0646\u0643 \u0644\u062d\u0633\u0627\u0628 \u0647\u062f\u0641 \u0627\u0644\u0628\u0631\u0648\u062a\u064a\u0646 \u0627\u0644\u062a\u0642\u062f\u064a\u0631\u064a.",
    meal_mixer_protein_per_day: "\u0628\u0631\u0648\u062a\u064a\u0646/\u0627\u0644\u064a\u0648\u0645",
    meal_mixer_protein_target_disclaimer: "\u0644\u0644\u062a\u062b\u0642\u064a\u0641 \u0641\u0642\u0637. \u0627\u062a\u0628\u0639 \u062e\u0637\u0629 \u0637\u0628\u064a\u0628\u0643 \u0623\u0648 \u0627\u062e\u062a\u0635\u0627\u0635\u064a \u062a\u063a\u0630\u064a\u0629 \u0627\u0644\u0643\u0644\u0649.",
    meal_mixer_more_foods: "\u0633\u064a\u062a\u0645 \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0623\u0637\u0639\u0645\u0629 \u0642\u0631\u064a\u0628\u0627\u064b.",
    meal_mixer_foods_available: "\u0637\u0639\u0627\u0645\u0627 \u0645\u062a\u0627\u062d\u0627",
    meal_mixer_meal_name: "\u0627\u0633\u0645 \u0627\u0644\u0648\u062c\u0628\u0629",
    meal_mixer_meal_name_placeholder: "\u0645\u062b\u0627\u0644: \u062a\u0628\u0648\u0644\u0629",
    meal_mixer_name_required: "\u0627\u0633\u0645 \u0627\u0644\u0648\u062c\u0628\u0629 \u0645\u0637\u0644\u0648\u0628 \u0642\u0628\u0644 \u0627\u0644\u062d\u0641\u0638.",
    meal_mixer_save_mixed_meal: "\u062d\u0641\u0638 \u0627\u0644\u0648\u062c\u0628\u0629 \u0627\u0644\u0645\u0631\u0643\u0628\u0629",
    meal_mixer_update_saved_meal: "\u062a\u062d\u062f\u064a\u062b \u0627\u0644\u0648\u062c\u0628\u0629 \u0627\u0644\u0645\u062d\u0641\u0648\u0638\u0629",
    meal_mixer_save_as_new: "\u062d\u0641\u0638 \u0643\u0648\u062c\u0628\u0629 \u062c\u062f\u064a\u062f\u0629",
    meal_mixer_saved_meal_saved: "\u062a\u0645 \u062d\u0641\u0638 \u0627\u0644\u0648\u062c\u0628\u0629 \u0627\u0644\u0645\u0631\u0643\u0628\u0629.",
    meal_mixer_saved_meal_updated: "\u062a\u0645 \u062a\u062d\u062f\u064a\u062b \u0627\u0644\u0648\u062c\u0628\u0629 \u0627\u0644\u0645\u0631\u0643\u0628\u0629.",
    meal_mixer_saved_meal_deleted: "\u062a\u0645 \u062d\u0630\u0641 \u0627\u0644\u0648\u062c\u0628\u0629 \u0627\u0644\u0645\u0631\u0643\u0628\u0629 \u0627\u0644\u0645\u062d\u0641\u0648\u0638\u0629.",
    meal_mixer_saved_section: "\u0627\u0644\u0648\u062c\u0628\u0627\u062a \u0627\u0644\u0645\u0631\u0643\u0628\u0629 \u0627\u0644\u0645\u062d\u0641\u0648\u0638\u0629",
    meal_mixer_saved_helper: "\u062d\u0641\u0638 \u0627\u0644\u0648\u062c\u0628\u0629 \u0627\u0644\u0645\u0631\u0643\u0628\u0629 \u064a\u0646\u0634\u0626 \u0637\u0639\u0627\u0645\u0627 \u0645\u0631\u0643\u0628\u0627 \u0642\u0627\u0628\u0644\u0627 \u0644\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645. \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u064a\u0648\u0645 \u064a\u0636\u064a\u0641\u0647 \u0625\u0644\u0649 \u0633\u062c\u0644 \u0627\u0644\u064a\u0648\u0645 \u0643\u0639\u0646\u0635\u0631 \u0648\u0627\u062d\u062f.",
    meal_mixer_saved_empty: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0648\u062c\u0628\u0627\u062a \u0645\u0631\u0643\u0628\u0629 \u0645\u062d\u0641\u0648\u0638\u0629 \u0628\u0639\u062f.",
    meal_mixer_ingredients: "\u0645\u0643\u0648\u0646\u0627\u062a",
    meal_mixer_updated: "\u062a\u0645 \u0627\u0644\u062a\u062d\u062f\u064a\u062b",
    meal_mixer_load_edit: "\u062a\u0639\u062f\u064a\u0644",
    meal_mixer_add_saved_history: "\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u064a\u0648\u0645",
    meal_mixer_saved_missing_note: "\u0628\u0639\u0636 \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062a \u0644\u062f\u064a\u0647\u0627 \u0628\u064a\u0627\u0646\u0627\u062a \u063a\u0630\u0627\u0626\u064a\u0629 \u0646\u0627\u0642\u0635\u0629. \u062a\u0645 \u0627\u0633\u062a\u062b\u0646\u0627\u0621 \u0627\u0644\u0642\u064a\u0645 \u0627\u0644\u0646\u0627\u0642\u0635\u0629 \u0645\u0646 \u0627\u0644\u0645\u062c\u0645\u0648\u0639.",
    meal_mixer_add_history: "\u0623\u0636\u0641 \u0627\u0644\u0648\u062c\u0628\u0629 \u0625\u0644\u0649 \u0633\u062c\u0644 \u0627\u0644\u064a\u0648\u0645",
    meal_mixer_history_saved: "\u062a\u0645\u062a \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0648\u062c\u0628\u0629 \u0625\u0644\u0649 \u0633\u062c\u0644 \u0627\u0644\u064a\u0648\u0645.",
    meal_mixer_ai_draft_available: "\u062a\u0648\u062c\u062f \u0648\u062c\u0628\u0629 \u0645\u0642\u062a\u0631\u062d\u0629 \u0645\u0646 \u0627\u0644\u0645\u0633\u0627\u0639\u062f",
    meal_mixer_ai_draft_import: "\u0627\u0633\u062a\u064a\u0631\u0627\u062f",
    meal_mixer_ai_draft_dismiss: "\u0625\u0644\u063a\u0627\u0621",
    meal_mixer_ai_draft_imported: "\u062a\u0645 \u0627\u0633\u062a\u064a\u0631\u0627\u062f \u0645\u0633\u0648\u062f\u0629 \u0627\u0644\u0648\u062c\u0628\u0629.",
    meal_mixer_ai_draft_no_matches: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0623\u0637\u0639\u0645\u0629 \u0645\u0637\u0627\u0628\u0642\u0629 \u0641\u064a \u0642\u0627\u0639\u062f\u0629 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0644\u0644\u0627\u0633\u062a\u064a\u0631\u0627\u062f.",
    meal_mixer_ai_draft_quantity_review: "\u0631\u0627\u062c\u0639 \u0643\u0645\u064a\u0627\u062a \u0627\u0644\u0645\u0643\u0648\u0646\u0627\u062a \u0642\u0628\u0644 \u062d\u0641\u0638 \u0623\u0648 \u062a\u0633\u062c\u064a\u0644 \u0647\u0630\u0647 \u0627\u0644\u0648\u062c\u0628\u0629.",
    meal_mixer_estimated_daily_target: "\u0647\u062f\u0641 \u0627\u0644\u0628\u0631\u0648\u062a\u064a\u0646 \u0627\u0644\u064a\u0648\u0645\u064a \u0627\u0644\u062a\u0642\u062f\u064a\u0631\u064a",
    meal_mixer_current_meal_protein: "\u0628\u0631\u0648\u062a\u064a\u0646 \u0627\u0644\u0648\u062c\u0628\u0629 \u0627\u0644\u062d\u0627\u0644\u064a\u0629",
    meal_mixer_remaining_today: "\u0627\u0644\u0645\u062a\u0628\u0642\u064a \u0627\u0644\u062a\u0642\u0631\u064a\u0628\u064a \u0627\u0644\u064a\u0648\u0645",
    meal_mixer_day_unit: "\u0627\u0644\u064a\u0648\u0645",
  },
};

export function t(lang, key) {
  return translations[lang]?.[key] ?? translations.en[key] ?? key;
}
